import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/common/Footer';

const TermsOfService = () => {
  return (
    <div className='min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8'>
      <div className='max-w-4xl mx-auto'>
        {/* Header */}
        <div className='mb-8'>
          <Link
            to='/home'
            className='inline-flex items-center text-blue-600 hover:text-blue-800 mb-4'
          >
            <ArrowLeft className='h-4 w-4 mr-2' />
            Back to Home
          </Link>
          <h1 className='text-3xl font-bold text-gray-900 mb-2'>
            Terms of Service
          </h1>
          <p className='text-gray-600'>
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        {/* Content */}
        <div className='bg-white rounded-lg shadow-sm p-8 space-y-8'>
          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Agreement to Terms
            </h2>
            <p className='text-gray-700 leading-relaxed'>
              By accessing and using PCSO E-Lotto, you accept and agree to be
              bound by the terms and provision of this agreement. If you do not
              agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Use License
            </h2>
            <div className='space-y-4'>
              <p className='text-gray-700 leading-relaxed'>
                Permission is granted to temporarily download one copy of the
                materials on PCSO E-Lotto's website for personal, non-commercial
                transitory viewing only. This is the grant of a license, not a
                transfer of title, and under this license you may not:
              </p>
              <ul className='list-disc list-inside text-gray-700 space-y-2 ml-4'>
                <li>modify or copy the materials</li>
                <li>
                  use the materials for any commercial purpose or for any public
                  display (commercial or non-commercial)
                </li>
                <li>
                  attempt to decompile or reverse engineer any software
                  contained on our website
                </li>
                <li>
                  remove any copyright or other proprietary notations from the
                  materials
                </li>
              </ul>
              <p className='text-gray-700 leading-relaxed mt-4'>
                This license shall automatically terminate if you violate any of
                these restrictions and may be terminated by us at any time. Upon
                terminating your viewing of these materials or upon the
                termination of this license, you must destroy any downloaded
                materials in your possession whether in electronic or printed
                format.
              </p>
            </div>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Age Requirements
            </h2>
            <p className='text-gray-700 leading-relaxed'>
              You must be at least 18 years old to use our services. By using
              our website, you represent and warrant that you are at least 18
              years of age and have the legal capacity to enter into this
              agreement.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Account Registration
            </h2>
            <div className='space-y-4'>
              <p className='text-gray-700 leading-relaxed'>
                To access certain features of our service, you may be required
                to register for an account. You agree to:
              </p>
              <ul className='list-disc list-inside text-gray-700 space-y-2 ml-4'>
                <li>
                  Provide accurate, current, and complete information during
                  registration
                </li>
                <li>Maintain and promptly update your account information</li>
                <li>Maintain the security of your password and account</li>
                <li>
                  Accept responsibility for all activities that occur under your
                  account
                </li>
                <li>
                  Notify us immediately of any unauthorized use of your account
                </li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Prohibited Uses
            </h2>
            <div className='space-y-4'>
              <p className='text-gray-700 leading-relaxed'>
                You may not use our service:
              </p>
              <ul className='list-disc list-inside text-gray-700 space-y-2 ml-4'>
                <li>
                  For any unlawful purpose or to solicit others to perform
                  unlawful acts
                </li>
                <li>
                  To violate any international, federal, provincial, or state
                  regulations, rules, laws, or local ordinances
                </li>
                <li>
                  To infringe upon or violate our intellectual property rights
                  or the intellectual property rights of others
                </li>
                <li>
                  To harass, abuse, insult, harm, defame, slander, disparage,
                  intimidate, or discriminate
                </li>
                <li>To submit false or misleading information</li>
                <li>
                  To upload or transmit viruses or any other type of malicious
                  code
                </li>
                <li>To collect or track the personal information of others</li>
                <li>
                  To spam, phish, pharm, pretext, spider, crawl, or scrape
                </li>
                <li>For any obscene or immoral purpose</li>
                <li>
                  To interfere with or circumvent the security features of our
                  service
                </li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Gaming and Betting
            </h2>
            <div className='space-y-4'>
              <p className='text-gray-700 leading-relaxed'>
                Our platform provides lottery and gaming services. By using
                these services, you acknowledge that:
              </p>
              <ul className='list-disc list-inside text-gray-700 space-y-2 ml-4'>
                <li>Gaming involves risk and you may lose money</li>
                <li>You are responsible for your own gaming decisions</li>
                <li>
                  We promote responsible gaming and encourage you to set limits
                </li>
                <li>
                  All gaming activities are subject to applicable laws and
                  regulations
                </li>
                <li>
                  We reserve the right to suspend or terminate accounts that
                  violate fair play rules
                </li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Payment Terms
            </h2>
            <div className='space-y-4'>
              <p className='text-gray-700 leading-relaxed'>
                All payments are processed securely through our payment
                partners. You agree to:
              </p>
              <ul className='list-disc list-inside text-gray-700 space-y-2 ml-4'>
                <li>Provide accurate payment information</li>
                <li>Pay all charges incurred by your account</li>
                <li>
                  Accept responsibility for all transactions made through your
                  account
                </li>
                <li>Comply with our refund and withdrawal policies</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Disclaimer
            </h2>
            <p className='text-gray-700 leading-relaxed'>
              The materials on PCSO E-Lotto's website are provided on an 'as is'
              basis. PCSO E-Lotto makes no warranties, expressed or implied, and
              hereby disclaims and negates all other warranties including
              without limitation, implied warranties or conditions of
              merchantability, fitness for a particular purpose, or
              non-infringement of intellectual property or other violation of
              rights.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Limitations
            </h2>
            <p className='text-gray-700 leading-relaxed'>
              In no event shall PCSO E-Lotto or its suppliers be liable for any
              damages (including, without limitation, damages for loss of data
              or profit, or due to business interruption) arising out of the use
              or inability to use the materials on our website, even if PCSO
              E-Lotto or its authorized representative has been notified orally
              or in writing of the possibility of such damage. Because some
              jurisdictions do not allow limitations on implied warranties, or
              limitations of liability for consequential or incidental damages,
              these limitations may not apply to you.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Accuracy of Materials
            </h2>
            <p className='text-gray-700 leading-relaxed'>
              The materials appearing on our website could include technical,
              typographical, or photographic errors. PCSO E-Lotto does not
              warrant that any of the materials on its website are accurate,
              complete, or current. PCSO E-Lotto may make changes to the
              materials contained on its website at any time without notice.
              However, PCSO E-Lotto does not make any commitment to update the
              materials.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>Links</h2>
            <p className='text-gray-700 leading-relaxed'>
              PCSO E-Lotto has not reviewed all of the sites linked to our
              website and is not responsible for the contents of any such linked
              site. The inclusion of any link does not imply endorsement by PCSO
              E-Lotto of the site. Use of any such linked website is at the
              user's own risk.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Modifications
            </h2>
            <p className='text-gray-700 leading-relaxed'>
              PCSO E-Lotto may revise these Terms of Service at any time without
              notice. By using this website, you are agreeing to be bound by the
              then current version of these terms of service.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Governing Law
            </h2>
            <p className='text-gray-700 leading-relaxed'>
              These terms and conditions are governed by and construed in
              accordance with the laws of the Philippines and you irrevocably
              submit to the exclusive jurisdiction of the courts in that state
              or location.
            </p>
          </section>

          <section>
            <h2 className='text-2xl font-semibold text-gray-900 mb-4'>
              Contact Information
            </h2>
            <p className='text-gray-700 leading-relaxed'>
              If you have any questions about these Terms of Service, please
              contact us at{' '}
              <a
                href='mailto:support@pcsoe-lotto.com'
                className='text-blue-600 hover:text-blue-800 underline'
              >
                support@pcsoe-lotto.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfService;
